import React, { useContext } from "react";

import {
  ToggleFieldWithLabel,
  NumberFieldWithLabel,
} from "@components/Form/Fields";
import { ActionablesContext } from "@contexts/ActionablesContext";
import { useFormikContext } from "formik";
import { BudgetContext } from "./context";
import { R } from "@utils/currency";

export const Breakdown = () => {
  const { readOnly } = useContext(ActionablesContext);
  const { submitForm, values } = useFormikContext();
  const {
    state: {
      isRetired,
      totalMonthlyCashflowIncome,
      totalMonthlyCashflowExpenses,
    },
  } = useContext(BudgetContext);

  return (
    <>
      <fieldset>
        <legend>Current Income Breakdown</legend>
        <ToggleFieldWithLabel
          onChange={submitForm}
          readOnly={readOnly}
          style={{ marginTop: "0", marginBottom: "0" }}
          label="Surplus income should automatically be invested into assets"
          name="invest_surplus"
          tooltip="Surplus income from salary for the year should be re-invested into discretionary assets."
        />
        <div className="flex flex-col sm:flex-row">
          {!isRetired && (
            <NumberFieldWithLabel
              readOnly
              label="Current income (before tax)"
              value={values.gross_monthly_current_income || "0"}
              name="gross_monthly_current_income"
              inputTooltip={
                "This includes employer contributions to retirement funds"
              }
            />
          )}
          <NumberFieldWithLabel
            readOnly
            label="Income from assets"
            name="totalIncomeFromInvestments"
          />
          <NumberFieldWithLabel
            readOnly
            label="Additional income drawn from assets"
            name="totalAdditionalIncomeFromInvestments"
            inputTooltip={
              "This is calculated by the system if you have a hybrid or autoamtic draw strategy."
            }
          />
          <NumberFieldWithLabel
            readOnly
            label="Total net income (After tax)"
            name="totalCurrentNetIncome"
            subtext={`${R(
              totalMonthlyCashflowIncome
            ).format()} from cashflow income`}
          />
        </div>
      </fieldset>

      <fieldset>
        <legend>Current Expense Breakdown</legend>
        {!isRetired && (
          <ToggleFieldWithLabel
            onChange={submitForm}
            readOnly={readOnly}
            style={{ marginTop: "0", marginBottom: "0" }}
            label="The budget expense deficit should automatically be withdrawn from assets"
            name="withdraw_deficit"
            tooltip="Withdraw additional income from discretionary assets to cover the budget deficit for the year."
          />
        )}
        <div className="flex flex-col sm:flex-row">
          <NumberFieldWithLabel
            readOnly
            label="Current expenses"
            name="monthly_current_budget"
          />
          <NumberFieldWithLabel
            readOnly
            label="Asset contributions"
            name="totalContributions"
          />
          <NumberFieldWithLabel
            readOnly
            label="Liability repayments"
            name="totalLiabilityRepayments"
          />
          <NumberFieldWithLabel
            readOnly
            label="Total expenses"
            name="totalCurrentNetExpense"
            subtext={`${R(
              totalMonthlyCashflowExpenses
            ).format()} from cashflow expenses`}
          />
        </div>
      </fieldset>
    </>
  );
};
